import { reducer as AppReducer } from './app/reducer';
import {
    connectRouter,
    routerMiddleware as createRouterMiddleware
} from 'connected-react-router';
import { reducer as ComposerReducer } from './composer/reducer';
import {
    applyMiddleware,
    combineReducers,
    createStore,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga'
import { rootSaga } from '../sagas';
import { StateType } from 'typesafe-actions';

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware()

const rootReducer = combineReducers({
    app: AppReducer,
    composer: ComposerReducer,
    router: connectRouter(history)
});

export const store = createStore(
    rootReducer,
    composeWithDevTools(
        applyMiddleware(
            createRouterMiddleware(history),
            sagaMiddleware
        )
    )
);

sagaMiddleware.run(rootSaga);


// SELECTA!
export const selectLoggedinUser = (state: RootState) => {
    const user = state.app.loggedInUser
    const imgProxy = "http://165.227.131.254:8080/40x/"
    return {
        name: user.name,
        url: user.url,
        photo: imgProxy + user.photo,
    }
}

export const selectLoadingStatus = (state: RootState): boolean => {
    return (state.app.loading || state.composer.loading)
}

export const selectLoggedInStatus = (state: RootState): boolean => {
    return (state.app.loggedInUser && state.app.loggedInUser.url !== "")
}

export const selectErrorMessage = (state: RootState): string => {
    return state.app.errorMessage
}

interface composerPost {
    h: string
    content: string
    photos: string[]
}

export const selectComposerPost = (state: RootState): composerPost => {
    return {
        h: "entry",
        content: state.composer.content,
        photos: state.composer.photos
    }
}

// MEDIA DATA TYPES
export interface Media {
    url: string
    datetime: string
    type: MediaType
    geo?: string
    tags?: string[]
    published?: boolean
}
export interface MediaStore {
    [k: string]: Media
}
type MediaType =
    | "photo"
    | "video"

export const selectMediaStore = (state: RootState): MediaStore => {
    const mediaStore: MediaStore = {
        "https://media.j4y.co/2018/d3be9878-372e-4a85-a9b9-a5c6a337c7fc.jpg": {
            url: "https://media.j4y.co/2018/d3be9878-372e-4a85-a9b9-a5c6a337c7fc.jpg",
            datetime: "2018-01-02",
            type: "photo",
            published: false
        },
        "https://media.j4y.co/2018/e8a63c73-4ade-4eb7-ae46-94988d9cf4b2.jpg": {
            url: "https://media.j4y.co/2018/e8a63c73-4ade-4eb7-ae46-94988d9cf4b2.jpg",
            datetime: "2018-01-03",
            type: "photo",
            published: false
        },
        "https://media.j4y.co/2018/277862b8-cfa2-4f80-bdef-6991ffbde258.jpg": {
            url: "https://media.j4y.co/2018/277862b8-cfa2-4f80-bdef-6991ffbde258.jpg",
            datetime: "2018-01-04",
            type: "photo",
            published: false
        },
        "https://media.j4y.co/2018/b50e43a8-965c-4049-a60b-5a6849e45b2d.jpg": {
            url: "https://media.j4y.co/2018/b50e43a8-965c-4049-a60b-5a6849e45b2d.jpg",
            datetime: "2018-01-05",
            type: "photo",
            published: false
        },
        "https://media.j4y.co/2018/de2d0ea7-7e15-4851-bd17-13b744a4727b.jpg": {
            url: "https://media.j4y.co/2018/de2d0ea7-7e15-4851-bd17-13b744a4727b.jpg",
            datetime: "2018-01-05",
            type: "photo",
            published: false
        },

        "https://media.j4y.co/2018/a99aae29-43fd-4253-b422-013435a62eb6.jpg": {
            url: "https://media.j4y.co/2018/a99aae29-43fd-4253-b422-013435a62eb6.jpg",
            datetime: "2018-01-05",
            type: "photo",
            published: false
        },
        "https://media.j4y.co/2018/897f6370-2d82-4cde-a207-99e6d937fce7.jpg": {
            url: "https://media.j4y.co/2018/897f6370-2d82-4cde-a207-99e6d937fce7.jpg",
            datetime: "2018-01-05",
            type: "photo",
            published: false
        },
        "https://media.j4y.co/2018/7bca7e88-7cf4-4246-bf16-9b3d82c807fc.jpg": {
            url: "https://media.j4y.co/2018/7bca7e88-7cf4-4246-bf16-9b3d82c807fc.jpg",
            datetime: "2018-01-05",
            type: "photo",
            published: false
        },
        "https://media.j4y.co/2015/20151128145949_56e3609a306c6.jpg": {
            url: "https://media.j4y.co/2015/20151128145949_56e3609a306c6.jpg",
            datetime: "2018-01-05",
            type: "photo",
            published: false
        },
    }

    return mediaStore;
}

export const selectMediaPage = (state: RootState): Media[][] => {

    // I have a map of all media and a list of IDs to show for the current page
    // the selector function grabs the media objects for the current page
    // and other selectors can format the current page into chunks/rows etc

    const mediaStore = selectMediaStore(state)

    const currentPage = [
        "https://media.j4y.co/2018/d3be9878-372e-4a85-a9b9-a5c6a337c7fc.jpg",
        "https://media.j4y.co/2018/e8a63c73-4ade-4eb7-ae46-94988d9cf4b2.jpg",
        "https://media.j4y.co/2018/277862b8-cfa2-4f80-bdef-6991ffbde258.jpg",
        "https://media.j4y.co/2018/b50e43a8-965c-4049-a60b-5a6849e45b2d.jpg",
        "https://media.j4y.co/2018/de2d0ea7-7e15-4851-bd17-13b744a4727b.jpg",
        "https://media.j4y.co/2018/a99aae29-43fd-4253-b422-013435a62eb6.jpg",
        "https://media.j4y.co/2018/897f6370-2d82-4cde-a207-99e6d937fce7.jpg",
        "https://media.j4y.co/2018/7bca7e88-7cf4-4246-bf16-9b3d82c807fc.jpg",
        "https://media.j4y.co/2015/20151128145949_56e3609a306c6.jpg",
    ]

    const postRowz: Media[][] = []
    const rlen = currentPage.length;
    for (let i = 0; i < rlen; i++) {
        if (i % 3 === 0) {
            let row: Media[] = []
            if (mediaStore[currentPage[i]]) {
                row = row.concat(mediaStore[currentPage[i]])
            }
            if (mediaStore[currentPage[i + 1]]) {
                row = row.concat(mediaStore[currentPage[i + 1]])
            }
            if (mediaStore[currentPage[i + 2]]) {
                row = row.concat(mediaStore[currentPage[i + 2]])
            }
            postRowz.push(row)
        }
    }
    console.log("POSTROWZ::: ", postRowz)

    return postRowz;
}

export type RootState = StateType<typeof rootReducer>;
